import "./block-video.scss";

const blockVideo = () => {
    let allBlockVideo = document.querySelectorAll('.im-block-video');
    if(!allBlockVideo.length) return;

    allBlockVideo.forEach(el => {

        let videoToPlay = el.querySelector('video');        
        let playButton = el.querySelector('.im-block-video__button-play');
        if(!playButton || !videoToPlay) return;

        playButton.addEventListener('click', () => {
            videoToPlay.play();
            videoToPlay.controls = true;
            playButton.classList.add('hide');
            el.classList.add('play');
            el.classList.remove('pause');
        })

        videoToPlay.onpause = () => {
            playButton.classList.remove('hide');
            videoToPlay.controls = false;
            el.classList.add('pause');
            el.classList.remove('play');
        }

    });
}

export default blockVideo;